import * as layout from '../../../components/markLayout.module.css';
import { MarkButton } from '../../../components/MarkControls';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
import type { GraphError } from '../../../hooks/useDripGraphValidation';
type Props = {
    errors: GraphError[];
    onStepClick?: (stepId: string) => void;
};
const GraphErrorsPanel: React.FC<Props> = ({ errors, onStepClick }) => {
    if (errors.length === 0) return null;
    return (
        <div
            role="alert"
            aria-live="polite"
            style={{
                backgroundColor: 'var(--mark-danger-surface)',
                marginTop: '1rem'
            }}
            className={layout.notice}
        >
            <P
                noDefaultMargin
                strong
                size="small"
                styles={{
                    color: 'var(--mark-danger)',
                    marginBottom: '0.4rem'
                }}
            >
                {errors.length} validation {errors.length === 1 ? 'error' : 'errors'}
            </P>
            <ul
                style={{
                    margin: 0,
                    paddingLeft: '1.4rem',
                    color: 'var(--mark-danger)'
                }}
            >
                {errors.map((err, i) => (
                    <li key={`${err.stepId ?? 'global'}-${i}`}>
                        {err.stepId && onStepClick ? (
                            <MarkButton type="button" onClick={() => onStepClick(err.stepId!)}>
                                {err.message}
                            </MarkButton>
                        ) : (
                            err.message
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};
export default GraphErrorsPanel;
